export const sendMessage = (message: string)=>{
    const phoneNumber = "5588988160822"; 
    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(url, "_blank");
}
